import { render, staticRenderFns } from "./ChartClickthroughs.vue?vue&type=template&id=45d833ca&scoped=true&"
import script from "./ChartClickthroughs.vue?vue&type=script&lang=js&"
export * from "./ChartClickthroughs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d833ca",
  null
  
)

export default component.exports